<template>
  <div id="editing-modal" class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>編集中ファイル強制解除</h2>
      </div>
      <div class="data-area">
        <ul class="del_st">
          <li>
            <span class="label">管理番号</span>
            <span>{{ fileObj.fdId }}</span>
          </li>
          <li>
            <span class="label">製品品番</span>
            <span>{{ fileObj.fileCode }}</span>
          </li>
          <li>
            <span class="label">編集中ユーザーID</span>
            <span>{{ fileObj.userId }}</span>
          </li>
          <li>
            <span class="label">編集中ユーザー名</span>
            <span>{{ fileObj.userName }}</span>
          </li>
          <li>
            <span class="label">編集開始日時</span>
            <span>{{ fileObj.editingDate }}</span>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="releaseFile">解除</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  <!-- ローディングモーダル -->
  <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import store from '../../store/index'

import axios from 'axios'
import * as AppUtils from '../../utils/App'
import * as Api from '../../utils/Api'
import {API_URL} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
export default {
  name: 'editingModal',
  store: store,
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    fileObj: Object
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      errorMessage: { text: '' }
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        // this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        // this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    onCancel: function () {
      this.modalShown = false
    },
    releaseFile: function () {
      let payload = {
        fdId: this.fileObj.fdId,
        filCode: this.fileObj.fdCode,
        userId: this.fileObj.userId,
        userName: this.fileObj.userName,
        editingDate: this.fileObj.editingDate
      }
      axios.post(API_URL.PLANNING + '/editing-release', payload
      ).then(response => {
        this.$store.dispatch('loadEditingList')
        this.modalShown = false
        let modalData = {
          messages: ['編集中の解除が完了しました。']
        }
        AppUtils.showModal(modalData)
      }).catch(error => {
        Api.handleError(error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  .label{
    min-width: 135px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
select{
  width: 196px;
}
.del_st {
  margin-left: 100px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/EditingModal.vue